/**
 * Analytics Module
 *
 * Lightweight conversion funnel tracking. Events are logged to console
 * and can be wired to any analytics backend (e.g., Plausible, PostHog,
 * or a custom /api/analytics endpoint) when ready.
 */

type FunnelEvent =
  | "page_view"
  | "login"
  | "save_parcel"
  | "claim_start"
  | "claim_success"
  | "merch_preview_open"
  | "merch_order_start"
  | "merch_checkout_redirect"
  | "merch_success"
  | "share";

interface EventPayload {
  event: FunnelEvent;
  properties?: Record<string, string | number | boolean>;
  timestamp: string;
}

const eventLog: EventPayload[] = [];

/**
 * Track a funnel event.
 * Currently logs to console; swap the implementation to send
 * events to your analytics backend.
 */
export function trackEvent(
  event: FunnelEvent,
  properties?: Record<string, string | number | boolean>
): void {
  const payload: EventPayload = {
    event,
    properties,
    timestamp: new Date().toISOString(),
  };

  eventLog.push(payload);
  console.log("[Analytics]", event, properties || "");
}

/**
 * Get all tracked events (for debugging or batch upload).
 */
export function getEventLog(): ReadonlyArray<EventPayload> {
  return eventLog;
}
